define('graphicalRequestKanbanFilterView',[
  'module',
  'marionette',
  'underscore',
  'app',
  'settings',
  'tariffScaleData',
  'datePickerPopoverMixin',
  'template!graphicalRequestKanbanFilterViewTpl'
], function(
  module,
  Marionette,
  _,
  App,
  Settings,
  tariffScaleData,
  datePickerPopoverMixin,
  viewTpl
) {
  'use strict';

  var KanbanBoardFilterView =  Marionette.LayoutView.extend({
    template: viewTpl,
    filtersName: 'graphicalRequestKanbanFilters',
    filters: {},

    events: {
      'change @ui.select': 'onChangeFilterSelect',
      'change @ui.inputText': 'onChangeFilterInput',
      'click @ui.clear': 'onClearFilter'
    },

    ui: {
      select: 'select',
      inputText: 'input[type=text]',
      inputDate: '.js-date-field',
      inputModDate: '.js-mod-date-field',
      blinder: '.filters-blinder',
      clear: '.ui-search-input a'
    },

    initialize: function() {
      this.filters = _.extend(this.filters, Settings.getFromMemory(this.filtersName));
    },

    serializeData: function() {
      return {
        tariffScale: tariffScaleData,
        filters: this.filters,
        users: this.options.users,
        userSecId: ''
      };
    },

    onShow: function() {
      $.material.init();
    },

    onRender: function() {
      datePickerPopoverMixin.kanbanBoardDataInit(
        this.ui.inputDate, 
        _.bind(this.onChangeFilterDate, this)
      );
      datePickerPopoverMixin.kanbanBoardDataInit(
        this.ui.inputModDate,
        _.bind(this.onChangeFilterDate, this)
      );
    },

    onChangeFilterDate: function($element) {
      var value = $element.val();
      
      if ($element.attr('name') === 'date' && value) {
        this.filters.date = value;
        this.filters.dateFrom = datePickerPopoverMixin.parseDateFrom(value);
        this.filters.dateTo = datePickerPopoverMixin.parseDateTo(value);
      } else if ($element.attr('name') === 'modDate' && value) {
        this.filters.modDate = value;
        this.filters.modDateFrom = datePickerPopoverMixin.parseDateFrom(value);
        this.filters.modDateTo = datePickerPopoverMixin.parseDateTo(value);
      }
      this._updateBoard();
    },

    onChangeFilterSelect: function(e) {
      var key = $(e.currentTarget).attr('name'),
        value = $(e.target).val() === 'all' || $(e.target).val() === '0'  ? '' : $(e.target).val();

      this.filters[key] = value;
      this._updateBoard();
    },

    onChangeFilterInput: function(e) {
      var key = $(e.currentTarget).attr('name'),
        value = $(e.currentTarget).val();

      this.filters[key] = value;
      this._updateBoard();
    },

    _updateBoard: function() {
      Settings.setToMemory(this.filtersName, this.filters);
      this.filters = _.extend(this.filters, Settings.getFromMemory(this.filtersName));     
      this.trigger('filter-change:update', this.filters);
      this.ui.blinder.show();
    },

    onClearFilter: function(e) {
      e.preventDefault();      
      var key = $(e.currentTarget).attr('name');

      if (!$(e.currentTarget).parent().find('[name='+ key +']').val()) {
        return;
      }

      $(e.currentTarget).parent().find('[name='+ key +']').val('');
      if (key === 'date') {
        this.filters.dateFrom = '';
        this.filters.dateTo = '';
        this.ui.inputDate.trigger('clear');
      } else if (key === 'modDate') {
        this.filters.modDateFrom = '';
        this.filters.modDateTo = '';
        this.ui.inputModDate.trigger('clear');
      }
      this.filters[key] = '';
      this._updateBoard();
    }
  });

  module.exports = KanbanBoardFilterView;
});
